<svg
    width="21"
    height="36"
    viewBox="0 0 21 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
        d="M2.00079 34.0059L18.0016 18.0051L2.00079 2.00426"
        stroke="#1D53A4"
        stroke-width="4"
        stroke-linecap="round" />
</svg>
